window.Reverb = window.Reverb || {};

Reverb.OrderTotaler = (function () {
  const formSelector = 'form.totalable';

  function totalOrderFields($form) {
    let itemAmount = parseFloat($form.find('[data-bind-keyup=\'order-amount-product\']').val()) || 0;
    const itemShipping = parseFloat($form.find('[data-bind-keyup=\'order-negotiated-shipping\']').val()) || 0;
    const itemTax = parseFloat($form.find('[data-bind-keyup=\'order-tax-rate\']').val()) || 0;
    const quantity = parseFloat($form.find('[data-bind-keyup=\'order-quantity\']').val()) || 1;
    const total = $form.find('[data-bind=\'order-total\']');

    itemAmount *= quantity;

    if (itemTax > 0) {
      itemAmount *= (1 + itemTax / 100);
    }

    const calculatedTotal = itemAmount + itemShipping;

    total.val(accounting.formatNumber(calculatedTotal, 2));
  }

  function totalOrderFieldsOnChange() {
    $(document).on('keyup', '[data-bind-keyup]', function () {
      const form = $(this).parents(formSelector);
      totalOrderFields(form);
    });
  }

  function totalExistingForms() {
    $(formSelector).each(function () {
      totalOrderFields($(this));
    });
  }

  function init() {
    totalOrderFieldsOnChange();
    totalExistingForms();
  }

  return {
    init,
  };
}());

$(() => {
  Reverb.OrderTotaler.init();
});
